/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as angular from 'angular';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

angular.module('CanvasWrapper').factory('InteractionPinch', PinchFactory);
/**
 * @namespace Pinch
 * @returns {CanvasWrapper.Interaction.Pinch}
 * @memberOf CanvasWrapper.Interaction
 * @constructor
 */
PinchFactory.$inject = ['InteractionHandleEvent'];
function PinchFactory(InteractionHandleEvent) {
	let handleEvent = InteractionHandleEvent;
	// Handles pinch
	function Pinch(displayNode, inertia) {
		let oldScale;
		let startDistance = 0;
		function pinchStart(e) {
			handleEvent(displayNode).on('touchmove', pinchMove);
		}

		function pinchMove(e) {
			let t = e.data.originalEvent.targetTouches;
			if (!t || t.length < 2) {
				return;
			}
			let dx = t[0].clientX - t[1].clientX;
			let dy = t[0].clientY - t[1].clientY;
			let distance = Math.sqrt(dx * dx + dy * dy);
			if (!displayNode._pinch) {
				displayNode._pinch = {
					p: {
						distance,
						date: new Date(),
					},
				};
				startDistance = distance;
				handleEvent(displayNode).emit('pinchstart', { distance });
				return;
			}

			let now: any = new Date();
			let interval = now - displayNode._pinch.p.date;
			if (interval < 12) {
				return;
			}
			let center = {
				x: (t[0].clientX + t[1].clientX) / 2,
				y: (t[0].clientY + t[1].clientY) / 2,
			};
			let scale = distance / displayNode._pinch.p.distance;
			let scaleChange = scale - oldScale;
			let event = {
				distance,
				startDistance,
				scale: distance / displayNode._pinch.p.distance,
				velocity: distance / interval,
				zoomIn: distance > startDistance,
				offsetX: -(center.x * scaleChange),
				offsetY: -(center.y * scaleChange),
				points: t[0],
				scaleChange,
				center,
				data: e.data,
			};
			oldScale = event.scale;
			if (Math.abs(startDistance - distance) >= 20) {
				handleEvent(displayNode).emit('pinchmove', event);
			}
			displayNode._pinch.pp = {
				distance: displayNode._pinch.p.distance,
				date: displayNode._pinch.p.date,
			};

			displayNode._pinch.p = {
				distance,
				date: now,
			};
		}

		function pinchEnd(e) {
			handleEvent(displayNode).removeListener('touchmove', pinchMove);
			if (!displayNode._pinch || displayNode._pinch.intervalId) {
				return;
			}
			if (inertia && displayNode._pinch.pp) {
				if (displayNode._pinch.intervalId) {
					return;
				}
				let interval = (new Date() as any) - displayNode._pinch.p.date;
				let velocity = (displayNode._pinch.p.distance - displayNode._pinch.pp.distance) / interval;
				let center = displayNode._pinch.p.center;
				let distance = displayNode._pinch.p.distance;
				displayNode._pinch.intervalId = setInterval(function () {
					if (Math.abs(velocity) < 0.04) {
						clearInterval(displayNode._pinch.intervalId);
						handleEvent(displayNode).emit('pinchend');
						displayNode._pinch = null;
						return;
					}
					let updatedDistance = distance + velocity * 12;
					let event = {
						scale: updatedDistance / distance,
						velocity,
						center,
						data: e.data,
						zoomIn: distance > startDistance,
					};
					handleEvent(displayNode).emit('pinchmove', event);
					distance = updatedDistance;
					velocity *= 0.8;
				}, 12);
			} else {
				handleEvent(displayNode).emit('pinchend');
				displayNode._pinch = null;
			}
		}

		displayNode.eventMode = EventMode.Static;
		handleEvent(displayNode).on('touchstart', pinchStart);
		handleEvent(displayNode).on('touchend', pinchEnd);
		handleEvent(displayNode).on('touchendoutside', pinchEnd);
	}

	return Pinch;
}
